import { paletteHelper, spacingHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { OutboundLink } from '../../../app-kit/components/OutboundLink/OutboundLink';

export const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

export const BodyTextExtraPadding = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
  padding-top: ${spacingHelper('large')};
`;

export const StyledOutboundLink = styled(OutboundLink)`
  color: ${paletteHelper('textSecondary')};

  &:hover,
  &:focus {
    color: ${paletteHelper('textPrimary')};
  }
`;

export const DataProviderContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${spacingHelper('large')};
  gap: ${spacingHelper('extraSmall')};
`;

export const StyledDataProviderOutboundLink = styled(OutboundLink)`
  text-decoration: none;
`;
